{
  "sharepoint": {
    "title": "SharePoint-spegling",
    "description": "Anslut din SharePoint-tenant för att automatiskt spegla publicerade dokument. Den här guiden kommer att leda dig genom installationsprocessen.",
    "steps": {
      "adminConsent": {
        "title": "Administratörsmedgivande",
        "description": "Bevilja behörigheter för att komma åt SharePoint",
        "header": "Administratörsmedgivande & behörigheter",
        "subtitle": "Bevilja nödvändiga behörigheter för SharePoint-integration",
        "adminRequiredDesc": "Du måste vara Privileged Role Administrator eller Global Administrator för att bevilja administratörsmedgivande för denna applikation.",
        "requiredPermissions": "Vi kommer att begära följande behörigheter:",
        "application": "Applikationsbehörigheter",
        "applicationDesc": "Applikationsbehörigheter låter North House agera utan inloggad användare. Detta är den behörighet vi använder efter installationsprocessen är klar.",
        "delegated": "Delegerade behörigheter",
        "delegatedDesc": "Delegerade behörigheter låter oss agera åt användarens räkning. Vi använder dessa behörigheter under installationsprocessen för att göra onboardingen enklare.",
        "sitesSelected": "Sites.Selected",
        "sitesSelectedDesc": "Åtkomst till specifika SharePoint-webbplatser efter att behörighet beviljats",
        "userRead": "User.Read",
        "userReadDesc": "Låter användare logga in i appen. Denna behörighet begärs alltid.",
        "whatHappensNext": "Vad händer härnäst:",
        "redirectToConsent": "Du kommer att omdirigeras till Microsofts medgivandeside",
        "reviewPermissions": "Granska och godkänn de begärda behörigheterna",
        "returnToContinue": "Återvänd för att fortsätta installationsprocessen",
        "grantConsent": "Administratörsmedgivande",
        "redirecting": "Omdirigerar..."
      },
      "signIn": {
        "title": "Logga in",
        "description": "Autentisera med Microsoft",
        "header": "Logga in med Microsoft",
        "subtitle": "Din autentiseringssession kommer att användas för att lista och välja SharePoint-sida. Se till att du har nödvändiga behörigheter för att komma åt den sida du vill integrera med.",
        "tenantId": "Tenant-ID:",
        "signInButton": "Logga in med Microsoft"
      },
      "selectDestination": {
        "title": "Välj destination",
        "description": "Välj sida eller bibliotek för spegling",
        "header": "Välj destination",
        "subtitle": "Välj SharePoint-sida eller bibliotek dit dokumenten ska speglas",
        "site": "Sida",
        "drive": "Dokumentbibliotek",
        "error": "Misslyckades att välja destination",
        "searchTab": "Sök sida",
        "manualTab": "Ange URL",
        "urlPlaceholder": "https://din-tenant.sharepoint.com/sites/sida-namn",
        "urlHint": "Klistra in URL:en till din SharePoint-sida. Du kan kopiera den från webbläsarens adressfält när du tittar på sidan.",
        "urlInvalid": "Ogiltig SharePoint-URL eller sidan är inte tillgänglig. Kontrollera URL:en och se till att du har åtkomst till sidan.",
        "siteFound": "Sida hittad",
        "noSitesFound": "Inga resultat hittades",
        "selectSiteFirst": "Välj en sida först"
      },
      "verifyAccess": {
        "title": "Verifiera åtkomst",
        "description": "Verifiera åtkomst till vald SharePoint-sida eller bibliotek",
        "header": "Verifiera åtkomst",
        "subtitle": "Vi kommer att verifiera åtkomst till vald SharePoint-sida eller bibliotek med applikationsåtkomst",
        "success": "Åtkomst verifierad",
        "error": "Misslyckades att verifiera åtkomst",
        "errorDescription": "Testa att ladda om sidan, annars kontakta oss på support@northhouse.se"
      },
      "grantAccess": {
        "title": "Bevilja appåtkomst",
        "description": "Bevilja North House åtkomst till vald destination",
        "header": "Bevilja appåtkomst",
        "subtitle": "Bevilja applikationsåtkomst till vald SharePoint-sida eller bibliotek",
        "info": "Vi kommer att lägga till en applikationsbehörighet för North House med rollen 'write' för det valda omfånget.",
        "error": "Misslyckades att bevilja applikationsåtkomst"
      }
    },
    "completion": {
      "header": "Installation klar",
      "subtitle": "Din SharePoint-spegling är konfigurerad och redo",
      "integrationActive": "Spegling aktiv"
    }
  },
  "msIntegration": {
    "tokenNotFound": "URL:en är ogiltig. Begär en ny och försök igen.",
    "title": "North House Microsoft-integration",
    "subtitle": "Slutför stegen nedan för att konfigurera Microsoft-integrationen för din organisation.",
    "sidebar": {
      "adminConsent": "Administratörsmedgivande",
      "adminConsentDesc": "Bevilja behörigheter till North House",
      "userMigration": "Överför tilldelningar",
      "userMigrationDesc": "Överför användartilldelningar till den nya appen",
      "speSetup": "Dokumentlagring",
      "speSetupDesc": "Konfigurera SharePoint Embedded och överför dokument"
    },
    "steps": {
      "adminConsent": {
        "title": "Administratörsmedgivande",
        "description": "Auktorisera North House att komma åt din Microsoft-tenant"
      },
      "userMigration": {
        "title": "Migrera användartilldelningar",
        "description": "Överför befintliga användartilldelningar till den nya applikationen",
        "skipButton": "Hoppa över detta steg"
      }
    },
    "permissionsRequired": "Nödvändiga behörigheter",
    "permissionsDescription": "Du kommer att bli ombedd att bevilja följande API-behörigheter i din tenant:",
    "ssoPermissions": "SSO-autentisering",
    "ssoPermissionsDesc": "email, offline_access, openid, profile - Krävs för säker enkel inloggning (SSO) med OpenID Connect",
    "userReadPermission": "User.Read",
    "userReadPermissionDesc": "Krävs alltid för att Microsoft Graph-integrationer ska fungera korrekt",
    "fileStoragePermission": "FileStorageContainer.Selected",
    "fileStoragePermissionDesc": "Används för SharePoint Embedded-integration. Låter North House skapa, komma åt och hantera isolerade containers i din tenant för dokumentlagring och synkronisering",
    "sitesSelectedPermission": "Sites.Selected",
    "sitesSelectedPermissionDesc": "Tillåter North House att spegla publicerade dokument till en specifik SharePoint-sida i er tenant. Den här funktionen är valfri. Att ge administratörsmedgivande ger inte åtkomst; behörighet för en sida måste uttryckligen beviljas.",
    "containerTypeRegPermission": "FileStorageContainerTypeReg.Selected",
    "containerTypeRegPermissionDesc": "Låter North House registrera containertyper i din tenant för SharePoint Embedded. Krävs för att skapa lagringscontainers för din organisations dokument.",
    "sensitivityLabelsPermission": "SensitivityLabels.Read.All",
    "sensitivityLabelsPermissionDesc": "Låter North House läsa känslighetsetiketter konfigurerade i din tenant. Används för att visa tillgängliga känslighetsetiketter och tillämpa dem på dokument.",
    "signIn": {
      "title": "Administratörsinloggning",
      "button": "Logga in med Microsoft",
      "signingIn": "Loggar in...",
      "error": "Misslyckades att initiera inloggning. Försök igen.",
      "description": "För att migrera användartilldelningar från din tidigare applikation behöver vi att du loggar in med ett administratörskonto. Detta gör att vi kan läsa de befintliga tilldelningarna och återskapa dem på den nya North House-applikationen.",
      "skipUserMigration": "Hoppa över och gör det manuellt i Entra"
    },
    "adminCheck": {
      "button": "Ge administratörsmedgivande",
      "isAdmin": "Administratörsroll verifierad",
      "description": "Konfigurera North House Entra-integration för att aktivera säker enkel inloggning (SSO) och SharePoint-integration för din organisation.",
      "details": "Denna process kommer att registrera North House som en service principal i din Microsoft Entra-tenant.",
      "privacyNote": "North House har endast tillgång till de resurser som uttryckligen godkänts och kan inte ta del av data utanför detta."
    },
    "error": {
      "title": "Installation misslyckades",
      "description": "Ett fel uppstod under integrationsinstallationen. Vårt team har blivit notifierade. Kontrollera att din SharePoint-URL är korrekt och försök igen. Kontakta support om problemet kvarstår på support@northhouse.se eller ring +46 (0)8 50 23 52 22."
    },
    "status": {
      "creatingContainer": "Skapar SharePoint lagringscontainer",
      "waitingForMigration": "Dokumentmigrering är schemalagd till i natt.",
      "migrating": "Migrera dokument",
      "completed": "All dokument har migrerats",
      "error": "Fel",
      "migratingDescription": "Förflyttar dokument till SharePoint Embedded. Du kan stänga detta fönster.",
      "failed": "misslyckade",
      "startNowTitle": "North House kommer att vara otillgängligt",
      "startNowButton": "Starta nu",
      "startNowWarning": "Applikationen kommer inte att vara tillgänglig under migreringen. Starta bara nu om inga användare arbetar i systemet.",
      "userAssignment": {
        "loadingAssignments": "Laddar befintliga tilldelningar...",
        "loadError": "Misslyckades att ladda tilldelningar. Inloggningssessionen kan ha gått ut.",
        "noAssignments": "Inga användar- eller grupptilldelningar hittades på den tidigare applikationen. Ingen migrering behövs.",
        "assignmentsFound_one": "Hittade {{count}} tilldelning att migrera:",
        "assignmentsFound_other": "Hittade {{count}} tilldelningar att migrera:",
        "migrateButton_one": "Migrera {{count}} tilldelning",
        "migrateButton_other": "Migrera {{count}} tilldelningar",
        "migrating": "Migrerar...",
        "migrateSuccess_one": "{{count}} tilldelning migrerades.",
        "migrateSuccess_other": "{{count}} tilldelningar migrerades.",
        "migratePartial": "{{migrated}} tilldelningar migrerades, men {{failed}} misslyckades. Du kan behöva tilldela dessa manuellt.",
        "migrateError": "Misslyckades att migrera tilldelningar. Försök igen eller tilldela användare manuellt.",
        "user": "Användare",
        "group": "Grupp"
      }
    }
  }
}
